export default __webpack_public_path__ + "static/media/no-package.d9ae4f66.svg";